export enum EnumOrigemPedido {
  Loja = 'loja',
  Multiloja = 'multiloja',
  Bot = 'bot',
  Garcom = 'garcom',
  Balcao = 'balcao',
  Ifood = 'ifood',
  Keeta = 'keeta',
  Food99 = '99food',
  Totem = 'totem',
}
